import {Client} from "../../Client.ts";
import {GlAccount} from '../../../../../hooks/useGLAccounts.ts';
import {VatDirection} from '../../../../../types/vatCodes.ts';
import type {RuleGroupConnectiveEnum, RuleOperatorEnum} from "../../../../../generated/enums.ts";

export const NO_VAT = "none" as const;
export type VatDirectionChoice = typeof NO_VAT | VatDirection;

export interface Rule {
    operand: string | number | Date,
    operator: RuleOperatorEnum,
    value_field_name: string,
    context: {
        ceiling?: string | number | Date
    } | null
}

export interface FormValues {
    business?: Client | null;
    relations?: { name: string; operator: RuleOperatorEnum }[];
    relation_iban?: string;
    booking_date?: Date | string;
    booking_date_operator?: RuleOperatorEnum;
    booking_date_upper?: Date | string;
    amount?: number;
    amount_operator?: RuleOperatorEnum;
    amount_upper?: number;
    descriptions?: { text: string; operator: RuleOperatorEnum }[];
    gl_account?: GlAccount | null;
    vat_direction?: VatDirectionChoice;
    vat_code?: string;

    [key: string]: any;
}

export interface BlacklistRulePreviewTransaction {
    id: string,
    description: string,
    relation_name: string,
    signed_amount: number,
    booking_date: string,
    business_name: string,
    general_ledger_account_id?: string | null,
}

export interface TransactionsGroup {
    business_name: string;
    transactions: BlacklistRulePreviewTransaction[];
}

export interface AutomationRule {
    rule_id: string,
    business_name: string,
    rule: {
        rules: Rule[],
        connective: RuleGroupConnectiveEnum
    }
}
